module.exports = __webpack_public_path__ + "img/livinglab-mini.41037fa4.svg";